/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import PropTypes from 'prop-types';
import { useState } from 'react';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { submitPql } from '../pql/submitPql';
import { loadAndOpenSalesChat } from '../utils/loadAndOpenSalesChat';
import { trackTalkToSalesPql } from '../utils/metricUtils';
import { ReducedOptionsModal } from './ReducedOptionsModal';
import { jsx as _jsx } from "react/jsx-runtime";
const UnassignableModal = ({
  handleIframeSizeChange,
  onClose,
  upgradeData,
  hideBackground,
  ModalComponent,
  modalRoot,
  isUpgradePoint
}) => {
  const [hasTracked, setHasTracked] = useState(false);
  const onModalView = () => {
    if (!hasTracked) {
      track('communicationMethodsInteraction', Object.assign({
        action: 'viewed unassignable modal'
      }, getUpgradeDataTrackingProperties(upgradeData)));
      submitPql(Object.assign({}, upgradeData, {
        isRetail: false,
        isAssignable: false
      }));
      trackTalkToSalesPql(upgradeData.app);
      setHasTracked(true);
    }
  };
  const handleClickChatTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable chat button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: false
    });
    onClose();
  };
  const handleClickCallTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
  };
  return /*#__PURE__*/_jsx(ReducedOptionsModal, {
    onModalView: onModalView,
    onClickChat: handleClickChatTrack,
    onClickCall: handleClickCallTrack,
    modalRoot: modalRoot,
    onClose: () => onClose(),
    isRetail: false,
    upgradeData: upgradeData,
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    ModalComponent: ModalComponent,
    isUpgradePoint: isUpgradePoint
  });
};
UnassignableModal.propTypes = Object.assign({
  handleIframeSizeChange: PropTypes.func,
  hideBackground: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  ModalComponent: PropTypes.elementType,
  modalRoot: PropTypes.object
}, upgradeDataPropsInterface);
export default UnassignableModal;